import * as App from '../app'
import * as Auth from '../pages/auth'
import * as CommunityConfig from '../pages/community-config'
import * as Login from '../pages/login'
import * as Request from '../request'

export interface ApiState {
  key: string,
  origin: string,
}
export interface SearchConfig {
  url: string,
}
export interface ReportingState {
  kibana_host: string
}
export interface SentryConfig {
  config: {
    environment: 'production' | 'staging',
  },
  url: string,
}
export interface RasaApi {
  url: string,
  key?: string,
}
export interface LinkShortener {
  url: string,
}
export interface LinkShare {
  url: string,
}
export interface State {
  api: ApiState,
  integrationsApi: ApiState,
  rasaApi: RasaApi,
  reporting: ReportingState,
  search: SearchConfig,
  next_issue?: any,
  sentry: SentryConfig,
  shorten: LinkShortener,
  share: LinkShare,
}
export interface WrappedState {
  config: State,
}

const initialState: State = {
  api: {
    key: '',
    origin: '',
  },
  integrationsApi: {
    key: '',
    origin: '',
  },
  rasaApi: {
    key: null,
    url: '',
  },
  reporting: {
    kibana_host: '',
  },
  search: {
    url: '',
  },
  sentry: {
    config: {
      environment: 'staging',
    },
    url: '',
  },
  share: {
    url: '',
  },
  shorten: {
    url: '',
  },
}
export const reducer = (state: State = initialState, action: any = null) => {
  switch (action.type) {
    case Request.successConstant(CommunityConfig.FETCH_COMMUNITY_CONFIG):
      return {
        ...state,
        next_issue: action.payload.response.next_issue,
      }
    case App.INITIALIZING_APPLICATION:
      return action.config
    case Request.errorConstant(Auth.VALIDATE_TOKEN):
      return {
        ...state,
        ...{
          api: {
            ...state.api,
            key: '',
          },
        },
      }
    case Request.successConstant(App.FETCH_RASA_TOKEN):
      return {
        ...state,
        ...{
          rasaApi: {
            ...state.rasaApi,
            key: action.payload.response,
          },
          search: {
            ...state.search,
            key: action.payload.response,
          },
        },
      }
    case Login.LOGIN_SUBMIT_SUCCESS:
      return {
        ...state,
        ...{
          api: {
            ...state.api,
            key: action.payload.response.RASA_ADMIN_UI_API_TOKEN,
          },
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/config/reducer.ts